import { Camera, Sparkles, Truck } from "lucide-react";

const STEPS = [
  {
    n: "01",
    icon: Camera,
    title: "Snap & Upload",
    body: "Take a photo of your junk, the hole in your wall, or that flat-pack sitting in the hallway. Drag & drop or use your phone camera.",
  },
  {
    n: "02",
    icon: Sparkles,
    title: "AI Instant Quote",
    body: "Our vision model scans volume, damage, complexity. You see an itemized price range in about 12 seconds — no phone tag.",
  },
  {
    n: "03",
    icon: Truck,
    title: "Crew Shows Up",
    body: "Pick a same-day or next-morning window. Uniformed crew arrives on-time, hauls / fixes / assembles, and you get before-and-after photos.",
  },
];

export default function HowItWorks() {
  return (
    <section id="how" data-testid="how-it-works-section" className="py-16 lg:py-24 bg-zinc-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="max-w-3xl">
          <div className="font-tactical text-[11px] uppercase tracking-[0.25em] text-[#0C2E2B] mb-2">The Process</div>
          <h2 className="font-display font-extrabold text-3xl sm:text-4xl lg:text-5xl text-zinc-900 leading-tight">
            Three moves. No estimates over the phone.
          </h2>
        </div>

        <div className="mt-12 grid grid-cols-1 md:grid-cols-3 gap-6">
          {STEPS.map((s, i) => (
            <div
              key={s.n}
              data-testid={`step-${i + 1}`}
              className="relative bg-white rounded-xl border-2 border-zinc-200 p-8 card-lift"
            >
              <div className="absolute -top-3 -left-3 bg-[#0C2E2B] text-[#FFDF00] font-mono-data font-black text-sm px-3 py-1 rounded">
                {s.n}
              </div>
              <s.icon className="w-8 h-8 text-[#0C2E2B] mb-4" strokeWidth={2.2} />
              <h3 className="font-display font-black text-xl text-zinc-900 mb-2">{s.title}</h3>
              <p className="text-sm text-zinc-600 leading-relaxed">{s.body}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
